import { Dialog, DialogProps } from '@material-ui/core';
import React from 'react';

const DialogView = ({
  isOpen,
  setOpen,
  children,
  ...props
}: Partial<DialogProps> & {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
}) => {
  // Get the curretn language and direction
  const currentLang = localStorage.getItem('language') || 'en';
  const isRTL = currentLang === 'ar';

  return (
    <Dialog
      dir={isRTL ? 'rtl' : 'ltr'}
      onClose={() => setOpen(false)}
      open={isOpen}
      maxWidth="sm"
      fullWidth
      //
      PaperProps={{
        style: { borderRadius: 16 },
      }}
      {...props}
    >
      {children}
    </Dialog>
  );
};

export default DialogView;
